import { Accordion, AccordionItem } from "@components/shared/Accordion";
import { Section, SectionHeading } from "@components/shared/Section";
import { useTranslations } from "@services/strings";
import Link from "next/link";

/** FAQ block with a link to the full help centre. */
export const Faq = ({
  title,
  items,
  tone = "white",
}: {
  title: string;
  items: AccordionItem[];
  tone?: "white" | "mist";
}) => {
  const { t } = useTranslations();

  return (
    <Section tone={tone}>
      <div className="grid gap-10 md:grid-cols-[0.8fr_1.2fr] md:gap-16">
        <div>
          <SectionHeading title={title} />
          <Link
            href="/help"
            className="mt-5 inline-block text-[15px] font-semibold text-ink underline decoration-mint decoration-2 underline-offset-4 hover:decoration-ink"
          >
            {t("site.common.readFaq")}
          </Link>
        </div>
        <Accordion items={items} />
      </div>
    </Section>
  );
};
